<template>
  <div class="bgc" v-if="test">
      <div class="bgc-kong">
          <div class="examTop">
              <div class="goBack" @click="goback">
                  <img src="../../assets/img/study/exam/icon_fanhui.png" alt/>
                  返回
              </div>
              <div class="examName">{{exam.examName}}</div>
              <div class="examTime">
                  剩余时间：
                  <div>{{ time.Hour }}</div>
                  :
                  <div>{{ time.Minute }}</div>
                  :
                  <div>{{ time.Second }}</div>
              </div>
          </div>
      </div>
    <div class="exam">
      <div class="examCont">
          <!--<div class="examTop1"></div>-->
          <!--<div class="examTop flex1">
            <div class="goBack" @click="goback">
              <img src="../../assets/img/study/exam/icon_fanhui.png" alt />
              返回
            </div>
            <div class="examName">{{exam.examName}}</div>
            <div class="examTime">
              剩余时间：
              <div>{{ time.Hour }}</div>:
              <div>{{ time.Minute }}</div>:
              <div>{{ time.Second }}</div>
            </div>
          </div>-->
        <div class="examType">
          <!-- 试题列表 -->
          <div
            class="examList"
            :class="`examList${item.id}`"
            :ref="`examList${item.id}`"
            v-for="(item, i) in examList"
            :key="i"
          >
            <div class="topic" flex>
              <div v-if="item.flag == 0" class="status">单选题</div>
              <div v-if="item.flag == 4" class="status status1">多选题</div>
              <div v-if="item.flag == 3" class="status status2">判断题</div>
              <div v-if="item.flag == 1" class="status">填空题</div>
              <div v-if="item.flag == 2" class="status status1">简答题</div>

              <div v-if="item.flag == 5" class="status status5">英汉翻译</div>
              <div v-if="item.flag == 6" class="status status6">阅读理解</div>
              <div v-if="item.flag == 7" class="status status7">名词解释</div>
              <div v-if="item.flag == 8" class="status status8">计算题</div>
              <div class="index">{{i+1}}.</div>
              <div class="text" v-html="item.content"></div>
            </div>
            <div class="option">
              <!-- 单选题目 -->

              <el-radio-group
                v-model="item.radio"
                @change="change($event,item.id)"
                v-if="item.flag == 0"
              >
                <div class="choose" v-for="(key, val) in item.optionss" :key="val">
                  <el-radio :label="val">
                    <span v-html="key"></span>
                  </el-radio>
                </div>
              </el-radio-group>
              <!-- 多选题目 -->
              <el-checkbox-group
                v-model="item.radio1"
                v-if="item.flag == 4&&flag"
                @change="handleChecked($event,item.id)"
              >
                <el-checkbox
                  class="choose"
                  :label="val"
                  v-for="(key, val) in item.optionss"
                  :key="val"
                >
                  <span v-html="key"></span>
                </el-checkbox>
              </el-checkbox-group>
              <!-- 判断题 -->
              <el-radio-group
                v-model="item.radio2"
                @change="change1($event,item.id)"
                v-if="item.flag == 3"
              >
                <div class="choose" v-for="(key, val) in item.selectOption" :key="val">
                  <el-radio :label="val">
                    <span v-html="key"></span>
                  </el-radio>
                </div>
              </el-radio-group>
              <!-- 填空题 -->
              <el-input
                      class="response"
                      type="textarea"
                      v-model="item.fill"
                      @input="changeFill($event,item.id)"
                      v-if="item.flag == 2 || item.flag == 1 || item.flag == 5 || item.flag == 6 || item.flag == 7 || item.flag == 8"
                      :autosize="{ minRows: 2}"
                      placeholder="请输入内容"
              ></el-input>
            </div>

          </div>
        </div>
      </div>
      <!-- 右侧答题卡 -->
      <div class="answer">
          <div class="answerTitile">

          </div>
        <div class="answerTop">
          <div class="whether">
            <div class="whetherItem">
              <div></div>
              <div>为已答</div>
            </div>
            <div class="whetherItem">
              <div></div>
              <div>为未答</div>
            </div>
          </div>
          <div class="num">
            你还有
            <span>{{num}}道题</span>未答
          </div>
        </div>
        <div class="answerCard">

           <div class="answerList flex2">
              <div :class="{ noAnswer: item.status == 0 }" v-for="(item, index) in cardList" :key="index" @click="goDingyue(item.id)">{{index+1}}</div>

          </div>
        </div>
<!--        <div class="submit" @click="submit">交卷</div>-->
        <div :class="disable?'submit_disable':'submit'" @click="submit">交卷</div>
<!--        <div class="submit_disable"  @click="submit">交2卷</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { examination, handPapers } from "../../assets/js/api.js";
import store from 'store'
import {MessageBox} from "element-ui";
let timer = null;
let singleAnswer = {};
export default {
  name: "exam",
  data() {
    return {
      disable:false,
      // 拿到数据之后 再进行数据展示
      test: false,
      flag: false,
      timeTotal: 0,
      doTime : 0,
      radio1: "上海",
      dingYue: "",
      time: {
        Hour: 0,
        Minute: 0,
        Second: 0,
      },
      // 后台数据
      c_e_id: 0,
      exam: "",
      // 试题列表
      examList: [],
      // 答题卡数据
      cardList: [],
      num: 0,
      // 答案
      answer: [],

    };
  },
  mounted() {
    // console.log(this.$route.query.c_e_id);
    if (!this.$route.query.c_e_id) {
      this.$router.push("/index");
      return
    }
    this.c_e_id = this.$route.query.c_e_id;
    window.scroll(0, 0);
    this.examData();
    // 定时器
  },
  beforeDestroy() {
    //页面关闭时清除定时器
    clearInterval(timer);
  },
  computed: {},
  watch: {},
  methods: {
    // 试卷
    examData() {
      examination(this.c_e_id).then((res) => {

        if (res.code == 200) {
          this.exam = res.data;
            res.data.bookdatas.forEach((item) => {
            this.$set(item, "radio", "");
            this.$set(item, "radio1", []);
            this.$set(item, "radio2", "");
          });
            res.data.bookdatas.forEach((item) => {
            this.$set(item, "status", "");
          });
          this.flag = true;
          this.examList = res.data.bookdatas;
          this.cardList = res.data.bookdatas;
          this.num = res.data.bookdatas.length;
          this.timeTotal = (res.data.allTime - 0) * 60;
          this.doTime = res.data.doTime*60;
          this.test = true;
          this.countdown();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    // 单选
    change(e, id) {
      console.log(e, id);
      this.changeCard(id, 0);
      singleAnswer = { id: id, option: e };
      this.changeAnswer(singleAnswer, id);
    },
    // 判断
    change1(e, id) {
      console.log(e, id);
      this.changeCard(id, 0);
      singleAnswer = { id: id, option: e };
      this.changeAnswer(singleAnswer, id);
    },
      // 填空题
      changeFill(e, id) {
          singleAnswer = { id: id, option: e };
          // console.log(singleAnswer.option);

          if (singleAnswer.option) {
              this.changeCard(id, 0);
          } else {
              this.changeCard(id, 1);
          }
          this.changeAnswer(singleAnswer, id);
      },
    // 多选
    handleChecked(e, id) {
      console.log(e, id, e.length);
      if (e.length > 0) {
        this.changeCard(id, 0);
      } else {
        this.changeCard(id, 1);
      }
      singleAnswer = { id: id, option: e };
      this.changeAnswer(singleAnswer, id);
    },
    // 改变答题卡的状态
    changeCard(id, cancel) {
      this.cardList.forEach((item) => {
          if (item.id == id) {
              // console.log(item.id);
              if (cancel == 0) {
                  // console.log("已做");
                  if (item.status == 0) {
                      this.num--;
                  }
                  item.status = 1;
              } else {
                  // console.log("未做");
                  if (item.status == 1) {
                      this.num++;
                  }

                  item.status = 0;
              }
          }
      });
    },
    // 改变答案
    changeAnswer(singleAnswer1, id) {
      // replace 判断是否替换答案
      let replace = 0;
      this.answer.findIndex((item) => {
        if (item.id == id) {
          item.option = singleAnswer1.option;
          replace = 1;
        }
      });
        if (replace == 0) {
            // console.log(singleAnswer1.option);
            // 如果清空了的输入框的内容 数组里面不添加内容
            if (singleAnswer1.option || singleAnswer1.option == 0) {
                this.answer.push(singleAnswer);
            }
        }
    },
    // 提交试卷
    submit() {
        let userTime = 0;
        console.log(this.timeTotal)
        userTime = this.exam.allTime - 0 - Math.floor((this.timeTotal - 0) / 60);
      /**
       * 交卷时间提示
       */
      if(this.doTime > this.exam.allTime*60-this.timeTotal){
        MessageBox.confirm('请于开始考试'+this.exam.doTime+'分钟后交卷', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          return
      }
      this.disable=true

      console.log(JSON.stringify(this.answer))
      handPapers(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.exam.id,JSON.stringify(this.answer)).then((res) => {

          if (res.code == 200) {
            let report = res.data
            // this.$router.replace({
            //   path: "/analysis",
            //   query: {"examId":this.exam.id,"examDoId":examDoId},
            // });
            this.$router.replace({
                path: "/report",
                query: {"examId": this.exam.id, userTime: userTime, "report": JSON.stringify(report)}
            });

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 返回上一页
    back() {
      this.$router.go(-1);
    },
    // 锚点定位
    goDingyue(id) {
      console.log(this.$refs[`examList${id}`][0].getBoundingClientRect());
      this.$el
        .querySelector(`.examList${id}`)
        .scrollIntoView({ block: "end", behavior: "smooth" });
    },
    countdown() {
      if (this.timeTotal <= 0) {
        return;
      } else {
        this.countDown();
        timer = setInterval(this.countDown, 1000);
      }
    },
    countDown() {
      if (this.timeTotal <= 0) {
        clearInterval(timer);
      }
      let timeTotal = this.timeTotal;
      let h = parseInt((timeTotal / 60 / 60) % 24);
      h = h < 10 ? "0" + h : h;
      let m = parseInt((timeTotal / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(timeTotal % 60);
      s = s < 10 ? "0" + s : s;
      this.time = {
        Hour: h,
        Minute: m,
        Second: s,
      };
      this.timeTotal = this.timeTotal - 0 - 1;
      // console.log(this.time.Second);
    },
  },
};
</script>
<style lang="less" scoped>
//.click-disable{
//  pointer-events: none;
//  background-color: #5e5f5e;
//}
.bgc {
  width: 100%;
  // padding-top: 20px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  // padding-bottom: 50px;
}
.bgc-kong {
    position: relative;
  width: 100%;
    height: 60px;
    border-radius: 20px 20px 0 0;
    font-size: 18px;
    /*text-align: center;*/
    /*line-height: 280px;*/
    color: rgba(142, 142, 142, 0.6);
    background-color: #ff6829;
    .examTop {
        /*width: 933px;*/
        display: flex;
        height: 60px;
        color: black;
        background-repeat: no-repeat;
        z-index: 2;
        .goBack {
            position: absolute;
            margin-top: 20px;
            left: 30px;
            cursor: pointer;
            font-size: 14px;
            display: flex;
            align-items: center;
            img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
        .examName {

            margin-top: 20px;
            margin-left: 310px;
            font-size: 22px;
        }

        .examTime {
            margin-left: 160px;
            display: flex;
            align-items: center;
            font-size: 16px;
            div {
                width: 40px;
                height: 40px;
                margin: 0 10px;
                text-align: center;
                line-height: 40px;
                background-color: #8d876f;
                border-radius: 5px;
            }
        }
    }

}
.exam {
    position: absolute;
  display: flex;
  justify-content: space-between;
  width: 1200px;
    margin: 10px auto;
}
.examCont {
  width: 933px;
  background-color: #fff;
  // padding-bottom: 50px;
  box-sizing: border-box;
  .examTop1 {
    height: 196px;
    background-color: #ffffff;
    z-index: 3;
  }

}
/deep/
.text img{
  width :50px;
  height: 25px;
}
.examType {
    /*margin: 0 55px;*/
  margin-top: 40px;
    margin-left: 80px;
  font-size: 14px;
  .examList {
    .topic {
      display: flex;
      align-items: center;
      .status {
        margin-right: 20px;
        width: 80px;
        height: 20px;
        line-height: 20px;
        color: #fff;
        text-align: center;
        border-radius: 15px;
        background-color: #029aff;
      }
      .status1 {
        background-color: #ff7402;
      }
      .status2 {
        background-color: #b502ff;
      }
      .status5 {
        background-color: #3f9951;
      }
      .status6 {
        background-color: #a9924f;
      }
      .status7 {
        background-color: #8dabba;
      }
      .status8 {
         background-color: #37b1a4;
      }
    }
    /deep/
    .option img{
      width :50px;
      height: 25px;
    }
    .option {
      margin-top: 10px;
      margin-left: 100px;
      .choose {
        display: block;
        margin-bottom: 10px;
      }
    }
    .filling {
      width: 100%;
      text-indent: 20px;
      margin-bottom: 30px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #ccc;
    }
    .response {
      //   margin-left: 40px;
      //   width: 600px;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 30px;
      box-sizing: border-box;
      border-radius: 5px;
    }
  }
}
// 右侧答题卡
.answer {
  position: fixed;
  top: 20px;
  // right: 0;
  right: calc((100vw - 1200px) / 2);
  width: 250px;
  height: 900px;
  background-color: #ffffff;
  .answerTitile {
    text-align: center;
    line-height: 40px;
    height: 40px;
    background-color: #ff6829;
    color: #ffffff;
    font-size: 18px;
  }
  .answerTop {
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid #eaeaea;
    text-align: center;
    .whether {
      display: flex;
      justify-content: center;
      .whetherItem {
        display: flex;
        align-items: center;
        div:first-child {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          overflow: hidden;
          background-color: #ff6829;
        }
        &:first-child {
          margin-right: 10px;
        }
        &:last-child {
          div:first-child {
            border: 1px solid #029aff;
            box-sizing: border-box;
            background-color: transparent;
          }
        }
      }
    }
    .num {
      margin-top: 5px;
      span {
        color: #ff0000;
      }
    }
  }
}
.answerCard {
  margin-top: 20px;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 60vh;
  .type {
    margin: 12px 0;
    padding-left: 10px;
    height: 24px;
    line-height: 24px;
    color: #029aff;
    font-size: 16px;
    border-left: 5px solid #029aff;
  }
  .answerList {
    margin: 0 30px;
    flex-wrap: wrap;
    width: 190px;
    // min-height: 60vh;
    // background-color: antiquewhite;
    div {
      cursor: pointer;
      width: 36px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      background-color: #ff6829;
      border-radius: 50%;
      margin-right: 41px;
      margin-bottom: 20px;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    .noAnswer {
      color: #029aff;
      border: 1px solid #029aff;
      box-sizing: border-box;
      background-color: transparent;
    }
  }
}
.submit {
  margin: 0 auto;
  margin-top: 30px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
  background-color: #ff6829;
  border-radius: 10px;
}
.submit_disable {
  margin: 0 auto;
  margin-top: 30px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
  background-color: #5e5f5e;
  border-radius: 10px;
  pointer-events: none;
}
// 答案解析
.result {
  font-size: 18px;
  color: #343434;
  margin-bottom: 20px;
  span {
    color: #029aff;
    margin: 0 5px;
  }
  .big {
    font-size: 34px;
  }
}
.resultBtn {
  margin-bottom: 20px;
  width: 180px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  color: #fff;
  background: #029aff;
}
.resultBtn1 {
  color: #343434;
  background-color: #eaeaea;
}
.analysis {
  margin-bottom: 40px;
  font-size: 18px;
  span {
    color: #029aff;
  }
}
/deep/ .el-radio {
  color: #343434;
}
</style>
